import { useMemo, useState } from "react";
import {
  Avatar,
  Badge,
  Button,
  Card,
  Col,
  Empty,
  Row,
  Tag,
  Tooltip,
} from "antd";
import {
  CarOutlined,
  DashboardOutlined,
  DeleteOutlined,
  EditOutlined,
  EnvironmentOutlined,
  IdcardOutlined,
  MailOutlined,
  PhoneOutlined,
  PlusOutlined,
  TeamOutlined,
  UserOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useFormik } from "formik";
import {
  getAdversaireValidationSchema,
} from "../../../components/declaration/form-validations/schemaValidations";
import AddAdversaire from "../modals/AddAdversaire";

const AdversairesTab = ({ sinistre, victimes, setRefetch }) => {
  const [isPieton, setIsPieton] = useState(null);
  const [wasAdversaireConducteur, setWasAdversaireConducteur] = useState(true);
  const [currentAdversaire, setCurrentAdversaire] = useState(null);
  const [isNewAdversaireModalVisible, setIsNewAdversaireModalVisible] =
    useState(false);

  const adversaires = useMemo(
    () => victimes?.filter((victime) => victime.adversaire === true) || [],
    [victimes]
  );


  const adversaireInitialValue = {
    items: [
      {
        pieton: "non",
        nom: "",
        prenom: "",
        telephone: "",
        profession: "",
        adresse: "",
        engin: {
          marque: "",
          puissance: "",
          immatriculation: "",
          usage: "PRIVE",
        },
        nombrePersonneTransportees: 0,
        conducteur: {
          nom: "",
          prenom: "",
          telephone: "",
          numeroPermis: "",
          categoriePermis: "B",
          dateDelivrance: null,
          lieuDelivrance: "",
          dateExpiration: null,
          qualite: "",
        },
        societeAssurance: "",
        typeSinistre: "",
        conduisait: "oui",
        provenance: "",
        destination: "",
        vitesse: 0,
        typeAdversaire: "",
      },
    ],
  };

  const adversaireFormik = useFormik({
    initialValues: adversaireInitialValue,
    validationSchema: getAdversaireValidationSchema(
      isPieton,
      wasAdversaireConducteur
    ),
  });

  const handleNewAdversaireOpen = () => {
    setCurrentAdversaire(null);
    setIsNewAdversaireModalVisible(true);
  };

  const handleNewAdversaireClose = () => {
    setIsNewAdversaireModalVisible(false);
    setIsPieton(null);
    adversaireFormik.resetForm();
    setWasAdversaireConducteur(true);
    setCurrentAdversaire(null);
  };


  const getTypeSinistreColor = (type) => {
    const colors = {
      MIXTE: 'red',
      MATERIEL: 'orange',
      CORPOREL: 'volcano'
    };
    return colors[type] || 'default';
  };

  const showModal = (adversaire) => {
    setIsNewAdversaireModalVisible(true);
    setCurrentAdversaire(adversaire);
  };

  const handleDelete = (adv) => {
    console.log(adv);
  }

  const getCardBorderColor = (type) => {
    const colors = {
      MATERIEL: '#fa8c16',
      CORPOREL: '#ff7a45',
      MIXTE: '#722ed1',
    };
    return colors[type] || '#1890ff';
  };

  const getTypeSinistreGradient = (type) => {
    const gradients = {
      MIXTE: 'linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)',
      MATERIEL: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
      CORPOREL: 'linear-gradient(135deg, #f87171 0%, #ef4444 100%)'
    };
    return gradients[type] || 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)';
  };


  return (
    <div style={{
      padding: '24px',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e0f2fe 100%)',
      minHeight: '100vh'
    }}>
      <div style={{ maxWidth: '1600px', margin: '0 auto' }}>
        {/* En-tête avec bouton et statistiques */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '10px 24px',
          marginBottom: '24px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
        }}>
          <Row gutter={24} align="middle">
            <Col xs={24} sm={24} md={12} lg={16}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                }}>
                  <TeamOutlined style={{ fontSize: '28px', color: 'white' }} />
                </div>
                <div>
                  <h2 style={{
                    fontSize: '24px',
                    fontWeight: '700',
                    color: '#1e293b',
                    margin: '0 0 4px 0'
                  }}>
                    Parties Adverses
                  </h2>
                  <p style={{
                    fontSize: '14px',
                    color: '#64748b',
                    margin: 0
                  }}>
                    Gestion des parties adverses impliquées dans le sinistre
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} style={{ textAlign: 'right' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '16px', flexWrap: 'wrap' }}>
                <Badge
                  count={adversaires.length}
                  showZero
                  style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                    fontSize: '16px',
                    height: '24px',
                    minWidth: '28px',
                    lineHeight: '20px',
                    marginBottom: '40px!important'
                  }}
                >
                  <span style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#475569',
                    marginRight: '35px'
                  }}>
                    Total
                  </span>
                </Badge>
                <Button
                  type="primary"
                  size="large"
                  icon={<PlusOutlined />}
                  onClick={handleNewAdversaireOpen}
                  disabled={sinistre?.sortDossier === "S" || sinistre?.sortDossier === "T"}
                  style={{
                    background: '#242166',
                    border: 'none',
                    height: '35px',
                    padding: '0 12px',
                    fontSize: '15px',
                    fontWeight: '600',
                    borderRadius: '10px',
                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                  }}
                >
                  Nouvelle Partie Adverse
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        {/* Grille des adversaires */}
        {adversaires.length ? (
          <Row gutter={[24, 24]}>
            {adversaires.map((adversaire) => (
              <Col xs={24} sm={24} md={12} lg={8} key={adversaire.codeId}>
                <Card
                  style={{
                    height: '100%',
                    borderRadius: '16px',
                    border: 'none',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    overflow: 'hidden',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
                  }}
                  styles={{ body: { padding: 0 } }}
                >
                  {/* Barre de couleur en haut */}
                  <div style={{
                    height: '6px',
                    background: getTypeSinistreGradient(adversaire.typeSinistre)
                  }} />

                  {/* Contenu de la carte */}
                  <div style={{ padding: '24px' }}>
                    {/* En-tête avec avatar et info */}
                    <div style={{ marginBottom: '20px' }}>
                      <Row justify="space-between" align="top">
                        <Col span={18}>
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                            <Avatar
                              size={64}
                              icon={adversaire.engin ? <CarOutlined /> : <UserOutlined />}
                              style={{
                                background: adversaire.engin
                                  ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                  : 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                flexShrink: 0
                              }}
                            />
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <h3 style={{
                                fontSize: '18px',
                                fontWeight: '700',
                                color: '#1e293b',
                                margin: '0 0 6px 0',
                                lineHeight: '1.3',
                                wordBreak: 'break-word'
                              }}>
                                {adversaire.personne.prenom} {adversaire.personne.nom}
                              </h3>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                <Tag
                                  icon={<IdcardOutlined />}
                                  style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    padding: '2px 8px',
                                    borderRadius: '6px',
                                    border: 'none',
                                    background: '#f1f5f9',
                                    color: '#475569'
                                  }}
                                >
                                  {adversaire.codeId}
                                </Tag>
                                <Tag
                                  color={adversaire.engin ? 'blue' : 'green'}
                                  icon={adversaire.engin ? <CarOutlined /> : <UserOutlined />}
                                  style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    padding: '2px 8px',
                                    borderRadius: '6px',
                                    border: 'none'
                                  }}
                                >
                                  {adversaire.engin ? 'Véhiculé' : 'Piéton'}
                                </Tag>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col span={6} style={{ textAlign: 'right' }}>
                          <Tag
                            style={{
                              fontSize: '11px',
                              fontWeight: '700',
                              padding: '6px 12px',
                              borderRadius: '8px',
                              background: getTypeSinistreGradient(adversaire.typeSinistre),
                              color: 'white',
                              border: 'none',
                              boxShadow: `0 2px 8px ${getTypeSinistreColor(adversaire.typeSinistre)}40`
                            }}
                          >
                            {adversaire.typeSinistre}
                          </Tag>
                        </Col>
                      </Row>
                    </div>

                    {/* Informations de contact */}
                    <div style={{
                      background: 'linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)',
                      borderRadius: '12px',
                      padding: '14px 16px',
                      marginBottom: '16px',
                      border: '1px solid #7dd3fc'
                    }}>
                      {adversaire.personne.telephone && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: adversaire.personne.email ? '8px' : '0' }}>
                          <div style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            background: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                          }}>
                            <PhoneOutlined style={{ color: '#0284c7', fontSize: '16px' }} />
                          </div>
                          <span style={{ fontSize: '14px', fontWeight: '600', color: '#0c4a6e', flex: 1 }}>
                            {adversaire.personne.telephone}
                          </span>
                        </div>
                      )}
                      {adversaire.personne.email && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            background: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                          }}>
                            <MailOutlined style={{ color: '#0284c7', fontSize: '16px' }} />
                          </div>
                          <span style={{
                            fontSize: '13px',
                            fontWeight: '500',
                            color: '#0c4a6e',
                            flex: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}>
                            {adversaire.personne.email}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Informations du véhicule */}
                    {adversaire.engin && (
                      <div style={{ marginBottom: '16px' }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '10px'
                        }}>
                          <div style={{
                            width: '4px',
                            height: '16px',
                            borderRadius: '2px',
                            background: 'linear-gradient(180deg, #3b82f6 0%, #2563eb 100%)'
                          }} />
                          <span style={{
                            fontSize: '12px',
                            color: '#64748b',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            Véhicule
                          </span>
                        </div>
                        <div style={{
                          background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                          borderRadius: '12px',
                          padding: '16px',
                          border: '2px solid #3b82f6'
                        }}>
                          <div style={{
                            fontSize: '20px',
                            fontWeight: '800',
                            color: '#1e40af',
                            marginBottom: '8px',
                            letterSpacing: '1px',
                            fontFamily: 'monospace'
                          }}>
                            {adversaire.engin.immatriculation}
                          </div>
                          <div style={{
                            fontSize: '15px',
                            color: '#1e40af',
                            fontWeight: '600',
                            marginBottom: '6px'
                          }}>
                            {adversaire.engin.marque} {adversaire.engin.modele}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            {adversaire.engin.couleur && (
                              <Tag style={{
                                background: 'white',
                                border: '1px solid #3b82f6',
                                color: '#1e40af',
                                borderRadius: '6px',
                                fontSize: '12px',
                                fontWeight: '600'
                              }}>
                                {adversaire.engin.couleur}
                              </Tag>
                            )}
                            {adversaire.vitesse && (
                              <Tag
                                icon={<DashboardOutlined />}
                                style={{
                                  background: 'white',
                                  border: '1px solid #3b82f6',
                                  color: '#1e40af',
                                  borderRadius: '6px',
                                  fontSize: '12px',
                                  fontWeight: '600'
                                }}
                              >
                                {adversaire.vitesse} km/h
                              </Tag>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Informations du conducteur */}
                    {adversaire.driver && (
                      <div style={{ marginBottom: '16px' }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '10px'
                        }}>
                          <div style={{
                            width: '4px',
                            height: '16px',
                            borderRadius: '2px',
                            background: 'linear-gradient(180deg, #f59e0b 0%, #d97706 100%)'
                          }} />
                          <span style={{
                            fontSize: '12px',
                            color: '#64748b',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            Conducteur
                          </span>
                        </div>
                        <div style={{
                          background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                          borderRadius: '12px',
                          padding: '14px',
                          border: '2px solid #f59e0b'
                        }}>
                          <div style={{
                            fontSize: '15px',
                            fontWeight: '700',
                            color: '#92400e',
                            marginBottom: '6px'
                          }}>
                            {adversaire.driver.prenom} {adversaire.driver.nom}
                          </div>
                          {adversaire.driver.telephone && (
                            <div style={{
                              fontSize: '13px',
                              color: '#b45309',
                              marginBottom: '6px',
                              fontWeight: '500'
                            }}>
                              📞 {adversaire.driver.telephone}
                            </div>
                          )}
                          {adversaire.driver.numeroPermis && (
                            <Tag style={{
                              background: 'white',
                              border: '1px solid #f59e0b',
                              color: '#92400e',
                              fontSize: '11px',
                              fontWeight: '600',
                              borderRadius: '6px'
                            }}>
                              Permis: {adversaire.driver.numeroPermis}
                            </Tag>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Trajet */}
                    {(adversaire.provenance || adversaire.destination) && (
                      <div style={{ marginBottom: '16px' }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '10px'
                        }}>
                          <div style={{
                            width: '4px',
                            height: '16px',
                            borderRadius: '2px',
                            background: 'linear-gradient(180deg, #a855f7 0%, #9333ea 100%)'
                          }} />
                          <span style={{
                            fontSize: '12px',
                            color: '#64748b',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            Trajet
                          </span>
                        </div>
                        <div style={{
                          background: 'linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)',
                          padding: '14px',
                          borderRadius: '12px',
                          border: '2px solid #a855f7'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            marginBottom: adversaire.nombrePersonneTransportees ? '10px' : '0'
                          }}>
                            <EnvironmentOutlined style={{ fontSize: '18px', color: '#7c3aed' }} />
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                              <span style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#6b21a8'
                              }}>
                                {adversaire.provenance || '?'}
                              </span>
                              <span style={{ fontSize: '16px', color: '#a855f7' }}>→</span>
                              <span style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#6b21a8'
                              }}>
                                {adversaire.destination || '?'}
                              </span>
                            </div>
                          </div>
                          {adversaire.nombrePersonneTransportees > 0 && (
                            <Tag
                              icon={<TeamOutlined />}
                              style={{
                                background: 'white',
                                border: '1px solid #a855f7',
                                color: '#6b21a8',
                                fontSize: '12px',
                                fontWeight: '600',
                                borderRadius: '6px'
                              }}
                            >
                              {adversaire.nombrePersonneTransportees} personne(s) transportée(s)
                            </Tag>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Description des dégâts */}
                    {adversaire.descriptionDegatsVictime && (
                      <div>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '10px'
                        }}>
                          <div style={{
                            width: '4px',
                            height: '16px',
                            borderRadius: '2px',
                            background: 'linear-gradient(180deg, #ef4444 0%, #dc2626 100%)'
                          }} />
                          <span style={{
                            fontSize: '12px',
                            color: '#64748b',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            Dégâts Constatés
                          </span>
                        </div>
                        <div style={{
                          fontSize: '14px',
                          color: '#7f1d1d',
                          background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                          padding: '14px',
                          borderRadius: '10px',
                          borderLeft: '4px solid #ef4444',
                          lineHeight: '1.6',
                          fontWeight: '500'
                        }}>
                          <WarningOutlined style={{ marginRight: '8px', color: '#dc2626' }} />
                          {adversaire.descriptionDegatsVictime}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Actions en bas de carte */}
                  <div style={{
                    borderTop: '1px solid #e2e8f0',
                    // padding: '16px 24px',
                    background: '#f8fafc',
                    display: 'flex',
                    justifyContent: 'space-around',
                    gap: '8px',
                    marginTop: '0',
                  }}>
                    <Button
                      type="text"
                      icon={<EditOutlined style={{ fontSize: '16px' }} />}
                      onClick={() => showModal(adversaire)}
                      style={{
                        flex: 1,
                        fontWeight: '600',
                        color: '#3b82f6',
                        height: '40px',
                        borderRadius: '8px',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#eff6ff';
                        e.currentTarget.style.color = '#1e40af';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.color = '#3b82f6';
                      }}
                    >
                      Modifier
                    </Button>
                    <Button
                      type="text"
                      icon={<DeleteOutlined style={{ fontSize: '16px' }} />}
                      onClick={() => handleDelete(adversaire.codeId)}
                      style={{
                        flex: 1,
                        fontWeight: '600',
                        color: '#ef4444',
                        height: '40px',
                        borderRadius: '8px',
                        transition: 'all 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#fef2f2';
                        e.currentTarget.style.color = '#dc2626';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.color = '#ef4444';
                      }}
                    >
                      Supprimer
                    </Button>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        ) : (
          <Card style={{
            borderRadius: '16px',
            border: 'none',
            boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
            padding: '40px'
          }}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <div>
                  <p style={{
                    fontSize: '16px',
                    color: '#64748b',
                    fontWeight: '500',
                    margin: '16px 0 8px 0'
                  }}>
                    Aucune partie adverse enregistrée
                  </p>
                  <p style={{
                    fontSize: '14px',
                    color: '#94a3b8',
                    margin: 0
                  }}>
                    Cliquez sur le bouton ci-dessus pour ajouter une partie adverse
                  </p>
                </div>
              }
            />
          </Card>
        )}
        <AddAdversaire
          open={isNewAdversaireModalVisible}
          adversaire={currentAdversaire}
          setOpen={setIsNewAdversaireModalVisible}
          sinistre={sinistre}
          onClose={handleNewAdversaireClose}
          onSaved={() => {
            if (typeof setRefetch === "function") {
              setRefetch((prev) => !prev);
            }
          }}
        // edit={editMode}
        />
      </div>
    </div>
  );
};

export default AdversairesTab;
